import { API_ENDPOINTS } from "../config/constants";
import config from "../../apiServices/appConfig";


import {
  BankResponse,
  CustomersResponse,
  KycResponse,
  CustomerResponse,
} from "../types/customer.types";

// Base URL for API requests
const { BASE_URL,API_VERSION } = config;


interface KycData {
  document_type: string;
  document_name: string;
  document_number: string;
  dateOfBirth: string;
  Nationality: string;
  nameOnCard: string;
}

interface CreateKycRequest {
  user_id: string;
  kyc: KycData[];
}

interface CreateTransactionRequest {
  from_user_id: string;
  to_user_id: string;
  benif_bank_id: string;
  amount: number;
}

export const customersApi = {
  getAllUsers: async (page = 1, limit = 50): Promise<CustomersResponse> => {
    const token = localStorage.getItem("access_token");
    const response = await fetch(
      `${BASE_URL}${API_VERSION}${API_ENDPOINTS.USER.GET_ALL}?page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );
    if (!response.ok) {

      const body = await response.json().catch(() => ({}));
      console.log(body,'from body')
      const error: any = new Error(body?.message || `Error fetching users: ${response.status}`);
      error.status = response.status;
      throw error;
    }
  
    return await response.json();
  },
  
  createUser: async (email: string, mobile: string): Promise<any> => {
    const token = localStorage.getItem("access_token");

    const response = await fetch(`${BASE_URL}${API_VERSION}/user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
      body: JSON.stringify({ email, mobile }),
    });
  
    const data = await response.json(); 
    if (!response.ok) {
      console.log(data, 'from data')
      throw new Error(data?.message || `${response.status}`);
    }
  
    return data;
  },

  getClientProfile: async (): Promise<any> => {
    const token = localStorage.getItem("access_token");

    const response = await fetch(`${BASE_URL}${API_VERSION}${API_ENDPOINTS.CLIENT.PROFILE}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
    });

    if (!response.ok) {
      throw new Error(`Error fetching client profile: ${response.status}`);
    }

    return await response.json();
  } ,


  createKyc: async (data: CreateKycRequest): Promise<any> => {
    const token = localStorage.getItem("access_token");

    const response = await fetch(`${BASE_URL}${API_VERSION}${API_ENDPOINTS.KYC.CREATE}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`Error creating KYC: ${response.status}`);
    }

    return await response.json();
  },

  createBank: async (
    userId: string,
    accountNumber: string,
    ifscCode: string
  ): Promise<any> => {
    const token = localStorage.getItem("access_token");

    const response = await fetch(`${BASE_URL}${API_VERSION}${API_ENDPOINTS.BANK.CREATE}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
      body: JSON.stringify({
        user_id: userId,
        account_number: accountNumber,
        ifsc_code: ifscCode,
      }),
    });
    const data = await response.json();

    if (!response.ok) {
      // Throw with full info
      throw {
        status: response.status,
        message: data.message || 'Unknown error'
      };
    }

    return data;
  },

  getKycDetails: async (userId: string): Promise<KycResponse> => {
    const token = localStorage.getItem("access_token");

    const response = await fetch(
      `${BASE_URL}${API_VERSION}${API_ENDPOINTS.KYC.GET_KYC_DETAILS}/${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error fetching KYC details: ${response.status}`);
    }

    return await response.json();
  },

  getBankDetails: async (userId: string): Promise<BankResponse> => {
    const token = localStorage.getItem("access_token");

    const response = await fetch(
      `${BASE_URL}${API_VERSION}${API_ENDPOINTS.BANK.GET_BANK_DETAILS}/${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error fetching bank details: ${response.status}`);
    }

    return await response.json();
  },
  getCustomerById: async (userId: string): Promise<CustomerResponse> => {
    const token = localStorage.getItem("access_token");

    const response = await fetch(
      `${BASE_URL}${API_VERSION}${API_ENDPOINTS.CUSTOMER.GET_CUSTOMER_BY_ID}/${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error fetching customer details: ${response.status}`);
    }

    return await response.json();
  },
  getKycByUserId: async (userId: string): Promise<KycResponse> => {
    const token = localStorage.getItem("access_token");

    const response = await fetch(
      `${BASE_URL}${API_VERSION}${API_ENDPOINTS.KYC.GET_KYC_BY_USER_ID}/${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error fetching KYC details: ${response.status}`);
    }

    return await response.json();
  },
  getBankByUserId: async (userId: string): Promise<BankResponse> => {
    const token = localStorage.getItem("access_token");

    const response = await fetch(
      `${BASE_URL}${API_VERSION}${API_ENDPOINTS.BANK.GET_BANK_BY_USER_ID}/${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );

    return await response.json();
  },
  createTransaction: async (data: CreateTransactionRequest): Promise<any> => {
    const token = localStorage.getItem("access_token");

    const response = await fetch(`${BASE_URL}${API_VERSION}${API_ENDPOINTS.TRANSACTION.CREATE}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
      body: JSON.stringify(data),
    });

    return await response.json();
  },
  getAllTransactions: async () : Promise<any> => {
    const token = localStorage.getItem("access_token");

    const response = await fetch(`${BASE_URL}${API_VERSION}${API_ENDPOINTS.TRANSACTION.GET_ALL}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
    });

    if (!response.ok) {
      throw new Error(`Error fetching transactions: ${response.status}`);
    }

    return await response.json();
  }

};
